import AES from '../../src/helpers/AES';

class API {

    inputOutputSettings = {
        baseurl: '',
        userName: '',
        password: '',
        middlewareUserName: '',
        middlewarePassword: ''
    }

    constructor(baseurl, username, password, middlewareUsernName, middlewarePassword) {
        this.inputOutputSettings.baseurl = baseurl;
        this.inputOutputSettings.userName = username;
        this.inputOutputSettings.password = password;
        this.inputOutputSettings.middlewareUserName = middlewareUsernName;
        this.inputOutputSettings.middlewarePassword = middlewarePassword;

    }

    getData = (path) => {
        let req = this.getReq(path);
        return fetch(req);
    }

    postData = (path, data, isEncrypted) => {
        let req = this.getReq(path, data, 'POST', isEncrypted);
        return fetch(req);
    }

    putData = (path, data) => {
        let req = this.getReq(path, data, 'PUT');
        return fetch(req);
    }

    deleteData = (path, data) => {
        let req = this.getReq(path, data, 'DELETE')
        return fetch(req);
    }



    getReq = (path, data, method, isEncrypted) => {
        let h = this.getheader(isEncrypted);
        let req = null;
        let encryptData = null;

        if (data) {

            if (isEncrypted) {
                encryptData = AES.encrypt(AES.GenerateRequest(data));
            }
            req = new Request(this.inputOutputSettings.baseurl + path, {
                method: method,
                headers: h,
                body: isEncrypted ? encryptData : JSON.stringify(data)
            });
        }
        else {
            req = new Request(this.inputOutputSettings.baseurl + path, {
                method: method ? 'GET' : method,
                headers: h
            });
        }

        return req;
    }

    getheader = (isEncrypted) => {
        let user = isEncrypted && isEncrypted === true ? this.inputOutputSettings.middlewareUserName : this.inputOutputSettings.userName;
        let pass = isEncrypted && isEncrypted === true ? this.inputOutputSettings.middlewarePassword : this.inputOutputSettings.password;

        let h = new Headers();
        h.append('Authorization', "Basic " + this.encodeBase64(user + ":" + pass));
        h.append('Content-Type', 'application/json');
        return h;
    }

    encodeBase64 = (input) => {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        let str = input;
        let output = '';

        for (let block = 0, charCode, i = 0, map = chars;
            str.charAt(i | 0) || (map = '=', i % 1);
            output += map.charAt(63 & block >> 8 - i % 1 * 8)) {

            charCode = str.charCodeAt(i += 3 / 4);

            if (charCode > 0xFF) {
                console.log("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
            }

            block = block << 8 | charCode;
        }

        return output;
    }
}

export default API;

// export const API = (baseurl, username, password) => {

//     const getData = (path) => {
//         let req = getReq(path);
//         return fetch(req)
//     }

//     const postData = (path, data) => {
//         let req = getReq(path, data);
//         return fetch(req)
//     }

//     const getReq = (path, data) => {
//         let h = getheader()
//         let req = null;

//         if (data) {
//             req = new Request(baseurl + "/" + path, {
//                 method: 'POST',
//                 headers: h,
//                 body: JSON.stringify(data)
//             })
//         }
//         else {
//             req = new Request(baseurl + "/" + path, {
//                 method: 'GET',
//                 headers: h
//             })
//         }

//         return req;
//     }

//     const getheader = () => {
//         let h = new Headers();
//         h.append('Accept', 'application/json')
//         h.append('Content-Type', 'application/json')
//         h.append('Authorization', "Basic " + encodeBase64(username + ":" + password))
//         return h;
//     }

//     const encodeBase64 = (input) => {
//         const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
//         let str = input;
//         let output = '';

//         for (let block = 0, charCode, i = 0, map = chars;
//             str.charAt(i | 0) || (map = '=', i % 1);
//             output += map.charAt(63 & block >> 8 - i % 1 * 8)) {

//             charCode = str.charCodeAt(i += 3 / 4);

//             if (charCode > 0xFF) {
//                 console.log("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
//             }

//             block = block << 8 | charCode;
//         }

//         return output;
//     }
// }